<template>
  <b-card :header="caption">
    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="lockGroupMappers" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter">
      <template slot="no" slot-scope="data">
        {{data.index + 1}}
      </template>
       <template slot="action" slot-scope="data">
        <button v-on:click="delLockFromMapper(data.item.lockId, data.item.lockGroupId)">Delete</button>
       </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="getRowCount(lockGroupMappers)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
    </nav>
  </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('./shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockGroupMappers/list'
const API_DELETE = BASE + '/api/lockGroupMappers/delete'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData (id) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockGroupId: id
  }
  let res = await postdata(API, parameters)
  return res.lockGroupMappers
}

async function deleteLockFromMapper (lockId, lockGroupId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockId: lockId,
    lockGroupId: lockGroupId
  }
  let res = await postdata(API_DELETE, parameters)
  return res.id
}

export default {
  name: 'lock-group-list-details',
  props: {
    caption: {
      type: String,
      default: 'List Locks for location'
    }
  },
  data: () => {
    return {
      lockGroupMappers: [],
      fields: {
        no: {key: 'no', label: 'No.', sortable: true},
        id: {key: 'id', sortable: true},
        lockGroupId: {key: 'lockGroupId', sortable: true},
        lockGroupName: {key: 'lockGroup.name', sortable: true},
        lockId: {key: 'lockId', sortable: true},
        lockName: {key: 'lock.lockName', label: 'Lock Name', sortable: true},
        lockAlias: {key: 'lock.lockAlias', label: 'Lock Alias', sortable: true},
        action: {label: 'Action'}
      },
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      filter: null
    }
  },
  mounted () {
    getData(this.$route.params.id).then(response => {
      this.$data.lockGroupMappers = response
    })
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount (lockGroupMappers) {
      return lockGroupMappers.length
    },
    delLockFromMapper (lockId, lockGroupId) {
      deleteLockFromMapper(lockId, lockGroupId)
      location.reload()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/LockGroupListDetails.vue